import React, {Component} from 'react';
class StepFinal extends Component {
    constructor(props){
        super(props);
    }
    
    render(){
        return(<div>
            <div className="form-row">
                <div className="col-md-12 form-group">
                    <div className="lowerPartTitle">
                        <h4>Thank you for applying for school meal benefits!</h4>
                    </div>
                </div>
            </div>
            <div className="form-row">
                <div className="col-md-12">
                    <div className="alert alert-success bg-color-2">
                        <p><strong>Your application has been submitted.</strong></p>
                        <p>You will hear from us soon with your certification decision!</p>
                    </div>
                </div>
                <div className="col-md-12 text-right">
                    <button className="btn btn-primary" onClick={()=>{
                        this.props.goToHome();
                    }}> <i className="fa fa-home"></i> Go to Manage Applications</button>
                </div>
            </div>
            </div>)
    }
}
export default StepFinal


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/SchoolMealProgram/newLunchApplication/stepFinal.jsx